import * as Yup from "yup";

export const schema = Yup.object().shape({
  userName: Yup.string().required("Введите логин"),
  password: Yup.string().required("Введите пароль"),
});
